// extracted by css-extract-rspack-plugin
export default {"root":"hOflsh","label":"bonr53"};